<template>
  <!--试题-->
  <div class="testList">
    <div
      v-for="(item, index) in jsonData"
      :key="index"
      class="test_wrap"
      :class="{img_border :item.TestType}"
    >
      <div slot="header" class="clearfix">
        <!--文字标题-->
        <div class="test_title" v-if="!item.TestType">
          <div style="font-size:16px" v-if="!item.Group">{{index+1}}、{{item.Title}}</div>
          <div style="font-size:16px" v-else>
            <div>{{index+1}}、{{item.Group}}</div>
            <div style="color:red">{{item.Title}}</div>
          </div>
        </div>
        <!--图片标题-->
        <div class="img_title" style="background:#fff" v-else>
          <span>{{index+1}}、</span>
          <el-image style="width: 250px; height: 150px" :src="item.Title" fit="contain"></el-image>
        </div>
      </div>
      <!--选项组-->
      <el-radio-group v-model="item.OptionsCheckID">
        <div
          v-for="(subItem,subIndex) in item.Options"
          :key="subIndex"
          :class="{img_warp:item.TestType}"
        >
          <!--文字选项-->
          <div v-if="!subItem.TestType">
            <el-radio style="height:30px;" :label="subItem.OptionsID">{{subItem.Content}}</el-radio>

            <!--这是添加的-->
            <div class="subTtemquestion" v-if="subItem.RelationQuestion&&subItem.RelationQuestion.length>0">
              <div v-for="(subItemlist,subItemindex) in subItem.RelationQuestion"  :key="subItemindex" class="abc">
                 <div class="subTtemquestionItem" >({{subItemindex+1}})、{{subItemlist.Title}}</div>
                  
             <el-radio-group v-model="subItemlist.OptionsCheckID">
                <p  v-for="(subItemlistItem,subItemlistItemIndex) in subItemlist.Options" :key="subItemlistItemIndex">
                  <el-radio :label="subItemlistItem.OptionsID">{{subItemlistItem.Content}}</el-radio>
                </p>
              </el-radio-group>
            </div>
              </div>
          </div>

          <!--图片选项-->
          <div class="img_box" v-else>
            <el-radio style="height:55px;" :label="subItem.OptionsID">
              <el-image style="width: 95px; height: 55px" :src="subItem.Content" lazy></el-image>
            </el-radio>
          </div>
        </div>
      </el-radio-group>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    jsonData: {
      default: []
    }
  }
};
</script>
<style lang="less" scoped>
.subTtemquestion {
  margin-left:20px;
p{
    height: 24px;
}
}
.abc{
    margin-top: 16px;
}
.subTtemquestionItem {
  font-size: 13px;
 
}
.testList {
  padding-left: 20px;
  height: 500px;
  overflow-y: auto;
}

.test_wrap {
  margin: 30px 0;
  font-size: 16px;
  color: #222;
}

.img_border {
  border-bottom: 1px solid #ddd;
}

.img_warp {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  display: inline-block;
  width: 33%;

  .img_box {
    display: flex;
    align-items: center;
    margin: 30px 0;
    padding-left: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TestList.vue